import { type BeforeMount } from "@monaco-editor/react";
import * as Monaco from "monaco-editor";

import { RoboqlCompletionProvider } from "./completion";
import { languageDef, configuration } from "./language";
import { defineRoboqlTheme } from "./theme";

const SINGLETON_COMPLETION_PROVIDER = new RoboqlCompletionProvider();

export { RoboqlCompletionProvider };
export { defineRoboqlTheme, ROBOQL_MONACO_THEME } from "./theme";

export function singletonCompletionProvider(): RoboqlCompletionProvider {
  return SINGLETON_COMPLETION_PROVIDER;
}

/**
 * Re-bake the RoboQL theme from the palette the document currently resolves.
 * Call this whenever the app's light/dark mode flips.
 */
export function refreshRoboqlTheme(monaco: typeof Monaco): void {
  defineRoboqlTheme(monaco);
}

export const roboqlEditorBeforeMount: BeforeMount = (monaco: typeof Monaco) => {
  defineRoboqlTheme(monaco);

  if (
    !monaco.languages
      .getLanguages()
      .some(
        (language: Monaco.languages.ILanguageExtensionPoint) =>
          language.id === "roboql",
      )
  ) {
    monaco.languages.register({ id: "roboql" });
    monaco.languages.setMonarchTokensProvider("roboql", languageDef);
    monaco.languages.setLanguageConfiguration("roboql", configuration);

    monaco.languages.registerCompletionItemProvider(
      "roboql",
      SINGLETON_COMPLETION_PROVIDER,
    );
  }
};
